module.exports = __webpack_public_path__ + "img/register_img.23a2096c.png";